import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setEmail('');
  };

  return (
    <footer className="bg-charcoal text-white py-16 mx-6 mb-6 rounded-3xl">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/7172763fbb93cac028282f1cc3909c2c.png" 
                alt="theintimateedit logo" 
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 text-sm mb-6 leading-relaxed">
              Creating magical moments, one surprise at a time
            </p>

            <div className="mb-6">
              <div className="text-sm font-medium mb-3">Stay Inspired</div>
              <form onSubmit={handleNewsletterSubmit} className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  className="flex-1 px-4 py-2 bg-white/10 border-0 border-b border-white/20 focus:border-coral outline-none transition-colors text-sm rounded-lg"
                  required
                />
                <button
                  type="submit"
                  className="px-6 py-2 bg-gradient-to-r from-coral to-pink rounded-lg hover:shadow-lg transition-all cursor-pointer whitespace-nowrap text-sm"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </form>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium mb-4 text-gray-400">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('gallery')} className="text-sm hover:text-coral transition-colors cursor-pointer">
                  Gallery
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('packages')} className="text-sm hover:text-coral transition-colors cursor-pointer">
                  Packages
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('quiz')} className="text-sm hover:text-coral transition-colors cursor-pointer">
                  Take Quiz
                </button>
              </li>
              <li>
                <a href="#" className="text-sm hover:text-coral transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#" className="text-sm hover:text-coral transition-colors cursor-pointer">
                  FAQs
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium mb-4 text-gray-400">Get in Touch</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-coral"></i>
                <span>(437) 267-2718</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-coral"></i>
                <span>hello@theintimateedit.ca</span>
              </li>
            </ul>

            <div className="mt-6">
              <div className="text-sm font-medium mb-3 text-gray-400">Follow Us</div>
              <div className="flex gap-3">
                <a href="#" className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-coral transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-coral transition-colors cursor-pointer">
                  <i className="ri-pinterest-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-coral transition-colors cursor-pointer">
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
          <div className="flex gap-6">
            <a href="https://instagram.com/theintimate.edit" target="_blank" rel="noopener noreferrer" className="hover:text-coral transition-colors cursor-pointer">Instagram</a>
          </div>
          
          <div>© 2025 theintimateedit</div>
          
          <div className="flex gap-6">
            <a href="#" className="hover:text-coral transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="hover:text-coral transition-colors cursor-pointer">Terms</a>
            <a href="https://marsdigitech.net" target="_blank" rel="nofollow" className="hover:text-coral transition-colors cursor-pointer">Built with 💓 by Mars Digitech</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
